// Eisprungrechner: Rechenkern, 1:1 aus dem fertilio Eisprungrechner (https://fertilio.de/eisprungrechner/)
// Ohne DOM und ohne Design. EisprungKern.berechne(eingabe) liefert entweder { fehler, feld }
// oder alle fertigen Anzeigetexte plus Rohdaten. Rechnet komplett im Browser, kein Server nötig.
// Alle Daten sind UTC-Mitternacht in Millisekunden, damit die Zeitumstellung nichts verschiebt.
var EisprungKern = (function () {
  'use strict';

  var DAY = 86400000;
  var MIN_LEN = 20, MAX_LEN = 45, MAX_ALTER_TAGE = 120;

  var TEXTE = {
    'fehler.keinStart': 'Bitte trag den ersten Tag deiner letzten Periode ein.',
    'fehler.zukunft': 'Das Datum liegt in der Zukunft. Bitte trag den ersten Tag deiner letzten Periode ein.',
    'fehler.zuAlt': 'Das Datum liegt mehr als 120 Tage zurück. Bitte trag deine letzte Periode ein.',
    'fehler.laenge': 'Bitte gib deine Zykluslänge in Tagen an (20 bis 45).',
    'fehler.spanne': 'Bitte gib deinen kürzesten und längsten Zyklus in Tagen an (20 bis 45).',
    'kontext.regelmaessig': 'Zyklus {n} Tage',
    'kontext.unregelmaessig': 'Zyklus {von} bis {n} Tage',
    'label.laeuft': 'Fruchtbare Tage laufen',
    'label.naechster': 'Nächster Eisprung',
    'eisprung.tag': 'voraussichtlicher Eisprung an Zyklustag {n}',
    'eisprung.spanne': 'möglicher Eisprung zwischen Zyklustag {von} und {bis}',
    'fenster.beste': 'Beste Chancen: {zeitraum}',
    'fenster.breit': 'Breites Fenster wegen der Schwankung. Ovulationstests machen es genauer.',
    'test.dieserZyklus': 'Schwangerschaftstest (dieser Zyklus)',
    'test.ab': 'Schwangerschaftstest ab',
    'hinweis.ueberfaellig': 'Laut deiner Angabe wäre deine Periode am {datum} fällig gewesen. Ist sie ausgeblieben, bringt ein Schwangerschaftstest Klarheit. Hast du nur ein älteres Datum eingetragen, ist die Hochrechnung ungenauer.',
    'hinweis.extrem': 'Zyklen kürzer als 21 oder länger als 35 Tage solltest du frauenärztlich abklären lassen.',
    'hinweis.schwankung': 'Schwankt dein Zyklus um mehr als 7 Tage, ist jede Kalenderschätzung grob. Ovulationstests helfen, und eine frauenärztliche Kontrolle ist sinnvoll.',
    'zyklen.fruchtbar': 'fruchtbar {zeitraum}',
    'zyklen.eisprungUngefaehr': 'Eisprung ~{datum}',
    'zyklen.eisprung': 'Eisprung {zeitraum}',
    'kalender.tag': '{datum}: {status}',
    'kalender.periode': 'Periode',
    'kalender.fruchtbar': 'fruchtbar',
    'kalender.beste': 'beste Chancen',
    'kalender.eisprung': 'Eisprung',
    'kalender.test': 'Testtag',
    'kalender.heute': 'heute'
  };

  function t(key, vars) {
    var v = TEXTE[key];
    if (!vars) return v;
    return v.replace(/\{([A-Za-z_][A-Za-z0-9_]*)\}/g, function (ganz, name) {
      return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : ganz;
    });
  }

  // ─── Datum ───
  function heuteUTC() { var n = new Date(); return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()); }
  function parseISO(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : NaN;
  }
  function iso(ts) { return new Date(ts).toISOString().slice(0, 10); }
  function add(ts, n) { return ts + n * DAY; }
  function tag(ts) { return new Date(ts).getUTCDate(); }
  function gleicherMonat(a, b) {
    var x = new Date(a), y = new Date(b);
    return x.getUTCMonth() === y.getUTCMonth() && x.getUTCFullYear() === y.getUTCFullYear();
  }

  // ─── Formate (de-DE, UTC) ───
  var fLang = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }); // Mittwoch, 14. Oktober
  var fKurz = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', day: 'numeric', month: 'short' });                  // 14. Okt.
  var fWoche = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }); // Mi., 14. Okt.
  var fMonat = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', month: 'long' });                                  // Oktober
  function dLang(ts) { return fLang.format(new Date(ts)); }
  function dKurz(ts) { return fKurz.format(new Date(ts)); }
  function dWoche(ts) { return fWoche.format(new Date(ts)); }
  function monat(ts) { return fMonat.format(new Date(ts)); }
  function monatKurz(ts) { return dKurz(ts).replace(/^\d+\.\s*/, ''); }                                              // Okt.
  // Spanne: gleicher Tag "14. Okt.", gleicher Monat "9.–15. Okt.", über den Monat "28. Okt. – 3. Nov."
  function spanne(a, b) {
    if (a === b) return dKurz(a);
    return gleicherMonat(a, b) ? tag(a) + '.–' + dKurz(b) : dKurz(a) + ' – ' + dKurz(b);
  }

  // ─── Eingaben ───
  // eingabe = { start: 'YYYY-MM-DD', modus: 'regelmaessig' | 'unregelmaessig',
  //             laenge, kurz, lang, luteal (Standard 14), periode (Standard 5) }
  function begrenzen(v) {
    v = parseInt(v, 10);
    if (isNaN(v)) return NaN;
    return Math.min(MAX_LEN, Math.max(MIN_LEN, v));
  }

  function eingabenLesen(e, t0) {
    var start = parseISO(e.start);
    if (isNaN(start)) return { fehler: t('fehler.keinStart'), feld: 'start' };
    if (start > t0) return { fehler: t('fehler.zukunft'), feld: 'start' };
    if (start < add(t0, -MAX_ALTER_TAGE)) return { fehler: t('fehler.zuAlt'), feld: 'start' };
    var kurz, lang;
    if (e.modus !== 'unregelmaessig') {
      kurz = lang = begrenzen(e.laenge);
      if (isNaN(kurz)) return { fehler: t('fehler.laenge'), feld: 'laenge' };
    } else {
      kurz = begrenzen(e.kurz);
      lang = begrenzen(e.lang);
      if (isNaN(kurz) || isNaN(lang)) return { fehler: t('fehler.spanne'), feld: 'spanne' };
      if (kurz > lang) { var x = kurz; kurz = lang; lang = x; }
    }
    return {
      start: start, kurz: kurz, lang: lang,
      luteal: parseInt(e.luteal, 10) || 14,
      periode: parseInt(e.periode, 10) || 5
    };
  }

  // ─── Modell ───
  // Offsets in Tagen ab Zyklusbeginn (0 = erster Periodentag = Zyklustag 1).
  // Eisprung = Zykluslänge minus Lutealphase, fruchtbar = 5 Tage davor bis 1 Tag danach,
  // beste Tage = 2 Tage davor bis Eisprung (Wilcox 1995). Unregelmäßig: Spanne aus kürzestem und längstem Zyklus.
  function modell(inp, t0) {
    var regelmaessig = inp.kurz === inp.lang;
    var schritt = Math.round((inp.kurz + inp.lang) / 2);
    var oMin = inp.kurz - inp.luteal - 1;
    var oMax = inp.lang - inp.luteal - 1;
    var lhTag = Math.max(inp.kurz - inp.luteal - 3, 5);

    function zyklus(k) {
      var s = add(inp.start, k * schritt);
      return {
        k: k,
        start: s,
        periodeEnde: add(s, inp.periode - 1),
        oVon: add(s, oMin), oBis: add(s, oMax),
        fVon: add(s, oMin - 5), fBis: add(s, oMax + 1),
        bVon: regelmaessig ? add(s, oMin - 2) : null, bBis: regelmaessig ? add(s, oMax) : null,
        lh: add(s, lhTag - 1),
        naechsteVon: add(s, inp.kurz), naechsteBis: add(s, inp.lang),
        test: add(s, inp.lang),
        oTag: oMin + 1, oTagBis: oMax + 1
      };
    }

    // Aktueller Zyklus = der erste, dessen fruchtbares Fenster noch nicht vorbei ist
    var k = 0;
    while (zyklus(k).fBis < t0 && k < 40) k++;
    return { inp: inp, regelmaessig: regelmaessig, schritt: schritt, zyklus: zyklus, k: k };
  }

  // ─── Kalender ───
  // Von min(heute, Zyklusstart) bis max(Testtag, Ende fruchtbare Tage), auf ganze Wochen Mo bis So erweitert.
  function kalender(m, c, vorher, t0) {
    var von = Math.min(t0, c.start);
    var bis = Math.max(c.test, c.fBis);
    if (vorher && vorher.test >= t0) bis = Math.max(bis, vorher.test);
    var wdVon = (new Date(von).getUTCDay() + 6) % 7; // Montag = 0
    var wdBis = (new Date(bis).getUTCDay() + 6) % 7;
    von = add(von, -wdVon);
    bis = add(bis, 6 - wdBis);

    var naechster = m.zyklus(m.k + 1);
    var zyklen = vorher ? [vorher, c, naechster] : [c, naechster];
    var testTag = vorher && vorher.test >= t0 ? vorher.test : c.test;
    var NAME = { periode: 'kalender.periode', fruchtbar: 'kalender.fruchtbar', beste: 'kalender.beste', eisprung: 'kalender.eisprung', test: 'kalender.test', heute: 'kalender.heute' };

    var tage = [];
    for (var ts = von; ts <= bis; ts = add(ts, 1)) {
      var status = [];
      zyklen.forEach(function (cy) {
        if (ts >= cy.start && ts <= cy.periodeEnde) status.push('periode');
        if (cy === c || cy === naechster) {
          if (ts >= cy.fVon && ts <= cy.fBis) status.push('fruchtbar');
          if (cy.bVon && ts >= cy.bVon && ts <= cy.bBis) status.push('beste');
          if (ts >= cy.oVon && ts <= cy.oBis) status.push('eisprung');
        }
      });
      if (ts === testTag) status.push('test');
      if (ts === t0) status.push('heute');
      var namen = status.map(function (s) { return t(NAME[s]); });
      tage.push({
        datum: iso(ts),
        tag: tag(ts),
        monatKurz: tag(ts) === 1 || ts === von ? monatKurz(ts) : null, // kleiner Monatsname am 1. und in der ersten Zelle
        status: status,
        ariaLabel: status.length ? t('kalender.tag', { datum: dLang(ts), status: namen.join(', ') }) : dLang(ts)
      });
    }
    return { wochentage: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'], tage: tage };
  }

  // ─── Berechnen ───
  // heuteISO nur für Tests, sonst leer lassen
  function berechne(eingabe, heuteISO) {
    var t0 = heuteISO ? parseISO(heuteISO) : heuteUTC();
    var inp = eingabenLesen(eingabe, t0);
    if (inp.fehler) return inp;

    var m = modell(inp, t0);
    var c = m.zyklus(m.k);
    var vorher = m.k > 0 ? m.zyklus(m.k - 1) : null;

    var r = {
      kontext: m.regelmaessig ? t('kontext.regelmaessig', { n: inp.kurz }) : t('kontext.unregelmaessig', { von: inp.kurz, n: inp.lang }),
      label: c.fVon <= t0 ? t('label.laeuft') : t('label.naechster'),
      eisprung: m.regelmaessig ? dLang(c.oVon) : spanne(c.oVon, c.oBis),
      eisprungZusatz: m.regelmaessig ? t('eisprung.tag', { n: c.oTag }) : t('eisprung.spanne', { von: c.oTag, bis: c.oTagBis }),
      fruchtbar: spanne(c.fVon, c.fBis),
      fruchtbarZusatz: m.regelmaessig ? t('fenster.beste', { zeitraum: spanne(c.bVon, c.bBis) }) : t('fenster.breit'),
      ovulationstestsAb: dWoche(c.lh)
    };

    // Läuft noch ein Zyklus, dessen fruchtbare Tage vorbei sind, zählen dessen Testtag und Periode
    var z = vorher && vorher.test >= t0 ? vorher : c;
    r.testLabel = z === vorher ? t('test.dieserZyklus') : t('test.ab');
    r.test = dWoche(z.test);
    r.naechstePeriode = m.regelmaessig ? dWoche(z.naechsteVon) : spanne(z.naechsteVon, z.naechsteBis);

    var hinweise = [];
    var erster = m.zyklus(0);
    if (erster.naechsteBis < t0) hinweise.push(t('hinweis.ueberfaellig', { datum: dKurz(erster.naechsteBis) }));
    if (inp.kurz < 21 || inp.lang > 35) hinweise.push(t('hinweis.extrem'));
    else if (inp.lang - inp.kurz > 7) hinweise.push(t('hinweis.schwankung'));
    r.hinweis = hinweise.join(' '); // leer = Hinweis ausblenden

    r.kalender = kalender(m, c, vorher, t0);

    r.naechsteZyklen = [];
    for (var j = m.k + 1; j <= m.k + 3; j++) {
      var cj = m.zyklus(j);
      r.naechsteZyklen.push({
        monat: monat(cj.fVon),
        fruchtbar: t('zyklen.fruchtbar', { zeitraum: spanne(cj.fVon, cj.fBis) }),
        eisprung: m.regelmaessig ? t('zyklen.eisprungUngefaehr', { datum: dKurz(cj.oVon) }) : t('zyklen.eisprung', { zeitraum: spanne(cj.oVon, cj.oBis) })
      });
    }

    // Rohdaten als ISO-Datum, z. B. für Klaviyo-Profil-Properties
    r.roh = {
      regelmaessig: m.regelmaessig,
      zyklusKurz: inp.kurz, zyklusLang: inp.lang, luteal: inp.luteal, periode: inp.periode,
      letztePeriode: iso(inp.start),
      aktuellerZyklusStart: iso(c.start),
      fruchtbarVon: iso(c.fVon), fruchtbarBis: iso(c.fBis),
      besteVon: c.bVon ? iso(c.bVon) : null, besteBis: c.bBis ? iso(c.bBis) : null,
      eisprungVon: iso(c.oVon), eisprungBis: iso(c.oBis),
      ovulationstestsAb: iso(c.lh),
      testtag: iso(z.test),
      naechstePeriodeVon: iso(z.naechsteVon), naechstePeriodeBis: iso(z.naechsteBis)
    };
    return r;
  }

  return { berechne: berechne, begrenzen: begrenzen, MIN_LEN: MIN_LEN, MAX_LEN: MAX_LEN };
})();


/* ===================== Oberfläche (Ovy) ===================== */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function txt(el, v) { if (el) el.textContent = v == null ? '' : v; }
  function isoLokal(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }

  ready(function () {
    var root = $('[data-ft]');
    if (!root) return;
    var form = $('[data-ft-form]', root);
    var datum = $('#ft-start', root);
    var laenge = $('#ft-laenge', root);
    var slider = $('#ft-slider', root);
    var kurz = $('#ft-kurz', root);
    var lang = $('#ft-lang', root);
    var fehler = $('[data-ft-fehler]', root);
    var ergebnis = $('[data-ft-ergebnis]', root);
    var modus = 'regelmaessig';
    var letztes = null;

    /* Datumsgrenzen beim Laden */
    var heute = new Date();
    var min = new Date(heute); min.setDate(min.getDate() - 120);
    datum.max = isoLokal(heute);
    datum.min = isoLokal(min);

    /* Zahl und Schieberegler synchron */
    function sliderFarbe() {
      var p = (slider.value - 20) / 25 * 100;
      slider.style.setProperty('--ft-fill', p + '%');
    }
    laenge.addEventListener('input', function () {
      var v = parseInt(laenge.value, 10);
      if (!isNaN(v)) { slider.value = Math.min(45, Math.max(20, v)); sliderFarbe(); }
    });
    laenge.addEventListener('blur', function () {
      var v = EisprungKern.begrenzen(laenge.value);
      laenge.value = isNaN(v) ? 28 : v;
      slider.value = laenge.value; sliderFarbe();
    });
    slider.addEventListener('input', function () { laenge.value = slider.value; sliderFarbe(); });
    sliderFarbe();
    [kurz, lang].forEach(function (f) {
      f.addEventListener('blur', function () { var v = EisprungKern.begrenzen(f.value); if (!isNaN(v)) f.value = v; });
    });

    /* Umschalter regelmäßig / unregelmäßig */
    var radios = $$('[data-ft-modus]', root);
    function setModus(m, fokus) {
      modus = m;
      radios.forEach(function (r) {
        var an = r.getAttribute('data-ft-modus') === m;
        r.setAttribute('aria-checked', an ? 'true' : 'false');
        r.tabIndex = an ? 0 : -1;
        if (an && fokus) r.focus();
      });
      $('[data-ft-regel]', root).hidden = m !== 'regelmaessig';
      $('[data-ft-unregel]', root).hidden = m === 'regelmaessig';
    }
    radios.forEach(function (r, i) {
      r.addEventListener('click', function () { setModus(r.getAttribute('data-ft-modus')); });
      r.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
        e.preventDefault();
        var n = radios[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : radios.length - 1)) % radios.length];
        setModus(n.getAttribute('data-ft-modus'), true);
      });
    });
    setModus('regelmaessig');

    /* Berechnen */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      datum.removeAttribute('aria-invalid');
      if (modus === 'unregelmaessig') {
        var a = EisprungKern.begrenzen(kurz.value), b = EisprungKern.begrenzen(lang.value);
        if (!isNaN(a) && !isNaN(b)) { if (a > b) { var x = a; a = b; b = x; } kurz.value = a; lang.value = b; }
      }
      var r = EisprungKern.berechne({
        start: datum.value,
        modus: modus,
        laenge: laenge.value,
        kurz: kurz.value, lang: lang.value,
        luteal: $('#ft-luteal', root).value,
        periode: $('#ft-periode', root).value
      });
      if (r.fehler) {
        txt(fehler, r.fehler); fehler.hidden = false;
        if (r.feld === 'start') { datum.setAttribute('aria-invalid', 'true'); datum.focus(); }
        return;
      }
      fehler.hidden = true; txt(fehler, '');
      letztes = r;
      zeigen(r);
    });

    function zeigen(r) {
      txt($('[data-ft="label"]', root), r.label);
      txt($('[data-ft="kontext"]', root), r.kontext);
      txt($('[data-ft="eisprung"]', root), r.eisprung);
      txt($('[data-ft="eisprungZusatz"]', root), r.eisprungZusatz);
      txt($('[data-ft="fruchtbar"]', root), r.fruchtbar);
      txt($('[data-ft="fruchtbarZusatz"]', root), r.fruchtbarZusatz);
      txt($('[data-ft="ovulationstestsAb"]', root), r.ovulationstestsAb);
      txt($('[data-ft="testLabel"]', root), r.testLabel);
      txt($('[data-ft="test"]', root), r.test);
      txt($('[data-ft="naechstePeriode"]', root), r.naechstePeriode);
      var h = $('[data-ft="hinweis"]', root);
      txt(h, r.hinweis); h.hidden = !r.hinweis;

      /* Kalender */
      var kal = $('[data-ft-kalender]', root);
      kal.innerHTML = '';
      r.kalender.tage.forEach(function (d) {
        var li = document.createElement('li');
        li.className = 'ft-tag' + d.status.map(function (s) { return ' is-' + s; }).join('');
        li.setAttribute('role', 'listitem');
        li.setAttribute('aria-label', d.ariaLabel);
        if (d.monatKurz) { var m = document.createElement('span'); m.className = 'ft-tag__monat'; m.textContent = d.monatKurz; li.appendChild(m); }
        var z = document.createElement('span'); z.className = 'ft-tag__zahl'; z.textContent = d.tag; li.appendChild(z);
        kal.appendChild(li);
      });

      /* Nächste Zyklen */
      var liste = $('[data-ft-zyklen]', root);
      liste.innerHTML = '';
      r.naechsteZyklen.forEach(function (z) {
        var li = document.createElement('li');
        ['monat', 'fruchtbar', 'eisprung'].forEach(function (k) {
          var s = document.createElement('span'); s.className = 'ft-zyklen__' + k; s.textContent = z[k]; li.appendChild(s);
        });
        liste.appendChild(li);
      });

      ergebnis.hidden = false;
      requestAnimationFrame(function () { ergebnis.classList.add('is-in'); });
      if (window.innerWidth <= 1024) {
        setTimeout(function () {
          var kopf = document.querySelector('.shopify-section--header, header');
          var off = kopf ? Math.min(kopf.getBoundingClientRect().height, 120) + 12 : 80;
          var ziel = ergebnis.getBoundingClientRect().top + window.pageYOffset - off;
          window.scrollTo({ top: ziel, behavior: 'smooth' });
        }, 60);
      }
      document.dispatchEvent(new CustomEvent('ovy:fruchtbare-tage', { detail: r.roh }));
    }

    /* Lead-Formular: Klaviyo Client-API, Termine als Profil-Properties */
    var lead = $('[data-ft-lead]', root);
    if (lead) {
      lead.addEventListener('submit', function (e) {
        e.preventDefault();
        var mail = $('#ft-mail', lead);
        var ok = $('#ft-consent', lead);
        var msg = $('[data-ft-lead-msg]', lead);
        var btn = $('button[type="submit"]', lead);
        mail.removeAttribute('aria-invalid');
        if (!mail.value || !mail.checkValidity()) { mail.setAttribute('aria-invalid', 'true'); txt(msg, 'Bitte gib eine gültige E-Mail-Adresse ein.'); msg.className = 'ft-lead__msg is-err'; mail.focus(); return; }
        if (!ok.checked) { txt(msg, 'Bitte bestätige kurz, dass wir dir E-Mails schicken dürfen.'); msg.className = 'ft-lead__msg is-err'; ok.focus(); return; }
        var company = lead.getAttribute('data-company');
        var list = lead.getAttribute('data-list');
        var roh = letztes ? letztes.roh : {};
        var props = { ft_quelle: 'Rechner fruchtbare Tage' };
        Object.keys(roh).forEach(function (k) { props['ft_' + k] = roh[k]; });
        btn.disabled = true;
        var fertig = function (gut) {
          btn.disabled = false;
          if (gut) {
            lead.classList.add('is-done');
            txt(msg, lead.getAttribute('data-success')); msg.className = 'ft-lead__msg is-ok';
          } else {
            txt(msg, 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.'); msg.className = 'ft-lead__msg is-err';
          }
        };
        document.dispatchEvent(new CustomEvent('ovy:fruchtbare-tage-lead', { detail: { email: mail.value, roh: roh } }));
        if (!company || !list) { fertig(false); if (window.console) console.warn('Rechner: Klaviyo-Liste fehlt in den Sektions-Einstellungen.'); return; }
        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-01-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: 'Rechner fruchtbare Tage',
            profile: { data: { type: 'profile', attributes: {
              email: mail.value,
              properties: props,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }).then(function (res) { fertig(res.ok); }).catch(function () { fertig(false); });
      });
    }
  });
})();
